import {useEffect, useRef} from "react";
export function useCustomEventListener(eventName, handler, element = window, options = {}) {
  const savedHandler = useRef();
  const {
    capture,
    passive,
    once
  } = options;
  useEffect(() => {
    savedHandler.current = handler;
  }, [handler]);
  useEffect(() => {
    if (!element?.addEventListener) {
      return;
    }
    const eventListener = (event) => {
      savedHandler?.current && savedHandler.current(event);
    };
    const opts = {
      capture,
      passive,
      once
    };
    element.addEventListener(eventName, eventListener, opts);
    return () => {
      element.removeEventListener(eventName, eventListener, opts);
    };
  }, [eventName, element, capture, passive, once]);
}
export function useEventListener(eventName, handler, element, options) {
  return useCustomEventListener(eventName, handler, element, options);
}
